import { getTemplate } from "../template-helper";
import Mustache from "mustache";
import { tr } from "../../util/locales";
import { formatValue } from "../../util/formatter";

const COMPONENT_NAME = "z-select" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class SelectComponent extends HTMLElement {
            constructor() {
                super();
                this.innerHTML = "" ;
                this.currentValue = null ;
            }

            connectedCallback(){
                this.currentValue = null ;
                this.init() ;
            }


            initMarkup(){
                if(this.initDone){ 
                    return  ; 
                }
                this.initDone = true ;
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

            }
            init(){
                this.initMarkup() ;
                this.select = this.querySelector("select") ;
                this.labelFields = (this.getAttribute("z-label-fields")||"").split(",").map(f=>f.trim()).filter(f=>!!f) ;
                this.fieldId = (this.getAttribute("z-field-id")||"_id") ;
                
                this.searchResults = [] ;
                this.currentValue = this.getAttribute("value") ;

                this.applyReadOnly() ;
                this.applyRequired() ;
                this.applyOptions() ;
                if(this.customValidity){
                    this.setCustomValidity(this.customValidity) ;
                }

                this.select.addEventListener("change", ()=>{
                    this.currentValue = this.select.value ;
                    this.dispatchEvent(new Event('change', {bubbles: true}));
                }) ;
            }

            applyOptions(){
                const strOptions = this.getAttribute("z-options") ;
                let objOptions = null;
                try{
                    objOptions = JSON.parse(strOptions) ;
                }catch(err){
                    objOptions = [] ;
                }
                this.select.innerHTML = "" ;
                const optionSelect = document.createElement("OPTION") ;
                optionSelect.value = "" ;
                optionSelect.innerHTML = tr("global.pleaseChoose") ;
                this.select.appendChild(optionSelect) ;
                let valueFound = false;
                for(let obj of objOptions){
                    const option = document.createElement("OPTION") ;
                    const mappedObj = this.mapValue(obj) ;
                    option.innerHTML = mappedObj.label ;
                    option.value = mappedObj.id ;
                    this.select.appendChild(option) ;
                    if(this.currentValue && option.value == this.currentValue){
                        valueFound = true;
                    }
                }
                if(!valueFound){
                    this.currentValue = "" ;
                }
                this.select.value = this.currentValue||"" ;
            }

            get value() {
                return this.select.value ;
            }
            
            set value(value) {
                this.currentValue = value;
                this.select.value = value ;
            }

            get required() {
                return this.select.hasAttribute("required") ;
            }
            
            set required(required) {
                this.select.setAttribute('required', required);
            }
            
            static get observedAttributes() {
                return ['value', 'readonly', "required", "z-options"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'value':
                        if(newValue !== this.currentValue){
                            this.value = newValue ;
                        }
                    break;
                    case 'required':
                        this.applyRequired();
                        break;
                    case 'readonly':
                        this.applyReadOnly() ;
                        break;
                    case 'z-options':
                        this.applyOptions() ;
                        break;
                }
            }

            applyReadOnly(){
                if(!this.select){ return ; }
                if(this.hasAttribute("readonly")){
                    this.select.disabled = true;
                }else{
                    this.select.disabled = false;
                }
            }

            mapValue(r){
                if(!r){
                    return {
                        id: null,
                        label: ""
                    } ;
                }
                
                var labelField = this.labelFields.map(function(f){ 
                    if(f.includes("{{")){ return f; }
                    return "{{"+f+"}}" ;
                }).join(" - ") ;
                Mustache.parse(labelField);
                let formattedRecord = JSON.parse(JSON.stringify(r)) ;
                Object.keys(formattedRecord).forEach(k=>{
                    formattedRecord[k] = formatValue(formattedRecord[k]) ;
                });
                var label = Mustache.render(labelField, formattedRecord); 
                return {
                    id: r[this.fieldId||"id"],
                    label: label 
                } ;
            }
            
            focus(){
                if(this.select && this.select.focus){
                    this.select.focus() ;
                }
            }
            checkValidity(){
                if(this.select && this.select.checkValidity){
                    return this.select.checkValidity() ;
                }
                return true;
            }

            applyRequired(){
                const required = this.hasAttribute("required") ;
                if(this.select){
                    if(required){
                        this.select.setAttribute("required", "required") ;
                    }else{
                        this.select.removeAttribute("required") ;
                    }
                }
            }

            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.select){
                    this.select.setCustomValidity(msg) ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, SelectComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
